import {ComponentProps, FC} from 'react';
import {
    IconName,
    iconRegistry,
    IconRegistry,
    IconVariant,
} from './@registry/iconRegistry';

type IconProps = ComponentProps<'svg'> & {
    name: IconName;
    variant?: IconVariant;
    size?: number;
};

export const Icon: FC<IconProps> = ({
    name,
    variant = 'stroke',
    size = 24,
    width = size,
    height = size,
    color = 'var(--color-icon-primary)',
    ...rest
}) => {
    const registry = iconRegistry as IconRegistry;
    const Resolved = registry[variant][name] ?? registry.stroke[name];
    return <Resolved color={color} width={width} height={height} {...rest} />;
};
